import { Injectable, ComponentFactoryResolver, Self } from '@angular/core';
import { ADN_PLUS, Action, ElementViewportPosition, TwoFactorAuthentication, UtilParam } from '../models'
import { InputBaseComponent } from '../controls/input-base.component';
import { CtrlBaseComponent } from '../controls/ctrl-base.component';
import { CtBodyComponent, CtButtonComponent, CtColumnComponent, CtEmailFormComponent, CtFormComponent, CtHeaderComponent, CtPanelComponent, CtRowComponent, CtSidebarComponent, CtStepperComponent, CtViewComponent, CtDialogComponent, CtOtpComponent } from '../controls';
import { BreadCrumbService, MenuService, PaintService, UtilService, HttpService, PlusAlertsService, PlusMessageService, StoreService, AuthService } from '.';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { PfComponents } from '../enums/pfComponents';


@Injectable()
export class ComponentService {

  private components = {
    'CtButton': CtButtonComponent,
    'CtColumn': CtColumnComponent,
    'CtRow': CtRowComponent,
    'CtBody': CtBodyComponent,
    'CtHeader': CtHeaderComponent,
    'CtView': CtViewComponent,
    'CtEmailForm': CtEmailFormComponent
  };

  constructor(
    private breadCrumbService: BreadCrumbService,
    private menuService: MenuService,
    private utilService: UtilService,
    private compiler: ComponentFactoryResolver,
    private paintService: PaintService,
    private plusMessageService: PlusMessageService,
    private plusAlertService: PlusAlertsService,
    private location: Location,
    private router: Router,
    private storeService : StoreService,
    private authService : AuthService
  ) { }

  getComponents() {
    return this.components;
  }

  getComponent(component) {
    return this.components[component];
  }

  utl_getComponentRef(component: string) {
    return this.utilService.getComponentRef(component);
  }

  getUtils() {
    let utils = [
      'utl_getComponentRef',
      'utl_get',
      'utl_getFromUtilParams',
      'utl_set',
      'utl_setToUtilParams',
      'utl_refresh',
      'utl_updateBindingAdn',
      'utl_updateBindingAdnIfNotNull',
      'utl_noUpdateBindingAdn',
      'utl_getData',
      'utl_getConditions',
      'utl_getActionsAndConditions',
      'utl_refreshComponents',
      'utl_hideWhenNull',
      'utl_getFormBindingAdn',
      'utl_getFormBindingAdnFromUtilParams',
      'utl_getTableSelectedAdn',
      'utl_getTableSelectedAdnFromUtilParams',
      'utl_getTableData',
      'utl_getTableDataFromUtilParams',
      'utl_showWhenNull',
      'utl_downloadFile',
      'utl_downloadReport',
      'utl_getCurrentPeriod',
      'utl_loadSelectOptions',
      'utl_enableIf',
      'utl_enableFormIf',
      'utl_triggerEvent',
      'utl_cleanForm',
      'utl_clearTable',
      'utl_openDialog',
      'utl_closeDialog',
      'utl_toggleElementsVisibility',
      'utl_hideElements',
      'utl_showElements',
      'utl_elementsNavigation',
      'utl_goto',
      'utl_back',
      'utl_getUrlParams',
      'utl_getUrlParamValue',
      'utl_deselectTables',
      'utl_selectAllRecords',
      'utl_clean',
      'utl_showComponentIf',
      'utl_triggerEventIf',
      'utl_disable',
      'utl_enable',
      'utl_storage',
      'utl_showHideFromResponse',
      'utl_resetStepItem',
      'utl_buildAdn',
      'utl_setContextAdn',
      'utl_changeStep',
      'utl_triggerEventIfNotNull',
      'utl_checkTableEdit',
      'utl_triggerIfNotTableRowSelected',
      'utl_triggerIfTableRowSelected',
      'utl_buildDynamicForm',
      'utl_setProperty',
      'utl_openSidebar',
      'utl_closeSidebar',
      'utl_nextStepV4',
      'utl_prevStepV4',
      'utl_show_message',
      'utl_hide_message',
      'utl_set_otp_data',
      'utl_navigateTo',
      'utl_set_state',
      'utl_get_state',
      'utl_delete_state',
      'utl_delete_all_states',
      'utl_open_GuidedTourDialog',
      'utl_flush_user_menu',
      'utl_setOtpModelFromRadioOnClickToMiniOtp'
    ];

    return utils;
  }

  getLayOutComponents() {
    let components = {
      'CtView': CtViewComponent,
      'CtPanel': CtPanelComponent,
      'CtHeader': CtHeaderComponent,
      'CtBody': CtBodyComponent
    };
    return components;
  }

  getFormComponents() {
    return {
      // 'CtFooter': CtFooterComponent,
      'CtHeader': CtHeaderComponent,
      'CtBody': CtBodyComponent
    };
  }

  utl_get(event) {
    let value = null;
    let component = this.utilService.getComponentRef(event.actionParams[0]);

    if (component)
      value = component.getValue();

    return { Data: value };
  }

  utl_getFromUtilParams(event) {
    let value = null;
    let component = this.utilService.getComponentRef(this.utilService.getEventUtilParam(event, 'componentId', 'constant'));

    if (component)
      value = component.getValue();

    return { Data: value };
  }

  utl_set(event: any, response: any) {
    let componentsId = event.actionParams;

    for (let componentId of componentsId) {
      this.utilService.setAdnToAnyComponent(componentId, response, event);
    }

    return { Data: response };
  }

  utl_setToUtilParams(event: any, response: any) {
    let componentId = this.utilService.getEventUtilParam(event, 'componentId', 'constant');
    this.utilService.setAdnToAnyComponent(componentId, response, event);
    return { Data: response };
  }

  utl_refresh(event: any, response: any) {
    let params = event.actionParams;
    let component = this.utilService.getComponentRef(params[0]);

    if (component.getCtType() === 'CtTable') {

      let vSelectRow = this.utilService.getEventUtilParam(event, 'cSelectRow', 'constant');

      component.onRefresh(vSelectRow);
    } else if (component.getCtType() === 'CtForm') {
      component.onRefresh();
    } else if (component.getCtType() === 'CtFormList') {
      component.onRefresh();
    }
  }

  utl_refreshComponents(event: any, response: any) {
    let params = event.actionParams;
    let actionParams = params.actionParams ? params.actionParams : params;
    for (let componentId of actionParams) {
      let component = this.utilService.getComponentRef(componentId);
      component.onRefresh();
    }
  }

  utl_updateBindingAdn(event: any, adn: any) {
    let params = event.actionParams;
    let form;

    //En caso de que intente bindear una lista de ADNs, toma únicamente el primero.
    if (adn instanceof Array)
      adn = adn[0];

    for (let p of params) {
      form = this.utilService.getComponentRef(p);
      form.updateBindingAdn(adn ? new ADN_PLUS(adn) : adn);
    }
    return { Data: adn };
  }

  utl_noUpdateBindingAdn(event: any, adn: any) {
    let cleanIfNull = event.utilParams.find(x => x.dataSource === 'field' && x.name === 'cleanIfNull');
    let params = event.actionParams;
    let form;

    //En caso de que intente bindear una lista de ADNs, toma únicamente el primero.
    if (adn instanceof Array)
      adn = adn[0];

    for (let p of params) {
      form = this.utilService.getComponentRef(p);

      if (cleanIfNull && !adn)
        setTimeout(() => form.updateBindingAdn(null));
      else
        setTimeout(() => form.noUpdateBindingAdn(adn ? new ADN_PLUS(adn) : adn));
    }
    return { Data: adn };
  }

  utl_updateBindingAdnIfNotNull(event: any, adn: any) {
    if (!adn)
      return;

    let params = event.actionParams;
    let form = this.utilService.getComponentRef(params[0]);

    //En caso de que intente bindear una lista de ADNs, toma únicamente el primero.
    if (adn instanceof Array)
      adn = adn[0];

    form.updateBindingAdn(adn ? new ADN_PLUS(adn) : adn);
  }

  utl_getData(event: any) {
    let param = event.utilParams[0];
    let value = null;
    switch (param.dataSource) {
      case "localStorage":
        value = localStorage.getItem(param.name);
        break;
      case "loggedUser":
        let loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        let entityField = loggedUser.ArrayEntities.List.find(x => {
          return x.Name === '' ? (x.Alias === param.name) : (x.Name === param.name);
        });
        if (entityField)
          value = entityField.Value;
        break;
    }

    return { Data: value };
  }

  utl_getLoggedUser() {
    return { Data: JSON.parse(localStorage.getItem("loggedUser")) };
  }

  utl_getActions(event) {
    let data = this.addActionsAndConditions(event);
    let newEvent = { actionParams: [] }
    newEvent.actionParams = data;
    return newEvent;
  }

  utl_getConditions(event) {
    let data = this.addActionsAndConditions(event);
    let newEvent = { conditionParams: [] }
    newEvent.conditionParams = data;
    return newEvent;
  }

  utl_getFormBindingAdn(event) {
    let form = this.utl_getComponentRef(event.actionParams[0]);
    if (!form) return false;
    form.bindFormToAdn();
    return { Data: form.getBindingAdn() };
  }

  utl_getFormBindingAdnFromUtilParams(event) {
    let formId = this.utilService.getEventUtilParam(event, 'formId', 'constant')
    return { Data: this.utl_getComponentRef(formId).getBindingAdn() };
  }

  /**
   * @param event 
   */
  utl_getTableSelectedAdn(event) {
    return { Data: this.utl_getComponentRef(event.actionParams[0]).getSelectedAdn() };
  }

  utl_getTableSelectedAdnFromUtilParams(event) {
    let table = this.utilService.getEventUtilParam(event, 'tableId', 'constant')
    return { Data: this.utl_getComponentRef(table).getSelectedAdn() };
  }

  utl_getTableData(event) {
    let tableData = this.utl_getComponentRef(event.actionParams[0]).getTableData();
    return { Data: tableData && tableData.length > 0 ? tableData : null };
  }

  utl_getTableDataFromUtilParams(event) {
    let table = this.utilService.getEventUtilParam(event, 'tableId', 'constant')
    let tableData = this.utl_getComponentRef(table).getTableData();
    return (tableData && tableData.length > 0) ? { Data: tableData } : null
  }

  /**
    Clear the form binding
    @param Form component ids
  */
  utl_cleanForm(event) {
    for (let compRef of event.actionParams) {
      let formComponent = this.utl_getComponentRef(compRef);

      if (formComponent && formComponent.getCtType() === 'CtForm')
        formComponent.updateBindingAdn(null);
    }
  }


  /**
    Clears the table rows.
    @param Table component ids
  */
  utl_clearTable(event) {
    for (let compRef of event.actionParams) {
      let tableComponent = this.utl_getComponentRef(compRef);

      if (tableComponent && tableComponent.getCtType() === 'CtTable') {
        tableComponent.setDynamicProperties(tableComponent, 'tableData', null);
        tableComponent.updateTable(false);
      }
      //tableComponent.clearTable();
    }
  }

  /**
   *
   * @param event
   * @category Visual
   * @edgBehavior Dependency,Reference
   */
  utl_showComponentIf(event, adnResp) {
    let sender = this.utl_getComponentRef(event.actionParams[0]);
    let argComponent = this.utl_getComponentRef(event.actionParams[1]);
    let ignoreBinding = event.utilParams.find(x => x.dataSource === 'field' && x.name === 'ignoreBinding');

    if (sender && (argComponent || adnResp)) {
      let adn = adnResp;

      if (!adn) {
        if (argComponent.getCtType() === 'CtForm')
          adn = (argComponent.getHasBinding() || ignoreBinding ? argComponent.getBindingAdn() : null);
        else if (argComponent.getCtType() === 'CtTable')
          adn = argComponent.getSelectedAdn();
      }

      let isVisible = this.evaluateExpression(event.utilParams, adn);
      sender.setHidden(!isVisible);
    }
  }

  /**
      Enables or disables the sender component depending on target component ADN data
      @param First param: sender component that triggers the event
      @param Second param: target component to check data
      @param Constant param collection: Fields to check on target component. Use another CONCAT field as check operator
  */
  utl_enableIf(event, adnResp): void {
    let sender = this.utl_getComponentRef(event.actionParams[0]);
    let argComponent = this.utl_getComponentRef(event.actionParams[1]);

    if (sender && (argComponent || adnResp)) {
      let adn = adnResp;

      if (!adn) {
        if (argComponent.getCtType() === 'CtForm')
          adn = (argComponent.getHasBinding() ? argComponent.getBindingAdn() : null);
        else if (argComponent.getCtType() === 'CtTable')
          adn = argComponent.getSelectedAdn();
      }

      let isEnabled = this.evaluateExpression(event.utilParams, adn);

      if (sender.getCtType() === 'CtButton')
        sender.setDisabled(!isEnabled);
      else
        sender.setReadOnly(!isEnabled);
    }
  }

  /**
      Enables or disables the CtForm component fields
      @param Sender CtForm component that triggers the event
      @param Check UTL constant type argument list with adn field names for check against form bindingAdn. Use another CONCAT field as check operator
      @param ALLOW_UPDATE (optional) UTL field type argument, enables or diisables the form with update option
      @param ALLOW_NULL (optional) UTL field type argument, true even if binding is null, otherwise false
      @param NEGATE_CHECK (optional) UTL field type argument, negates the check expression result
      @param Exceptions (optional) From second argument, a list of event fields to exclude from the action
  */
  utl_enableFormIf(event, adn): void {
    let sender = this.utl_getComponentRef(event.actionParams[0]);

    if (sender && sender.getCtType() === 'CtForm') {
      if (!adn)
        adn = (sender.getHasBinding() ? sender.getBindingAdn() : null);
      let isEnabled = this.evaluateExpression(event.utilParams, adn);
      let allowUpdate = event.utilParams.find(x => x.dataSource === 'field' && x.name === 'ALLOW_UPDATE');
      let exceptions = [];

      for (var i = 1; i < event.actionParams.length; i++)
        exceptions.push(this.utl_getComponentRef(event.actionParams[i]).getModelId());

      if (allowUpdate) {
        if (isEnabled)
          sender.enableFormAllowUpdate(exceptions);
        else
          sender.disableFormPreventUpdate(exceptions);
      } else {
        if (isEnabled)
          sender.enableForm(exceptions);
        else
          sender.disableForm(exceptions);
      }
    }
  }

  utl_hideWhenNull(event, response) {
    let params = event.actionParams;
    if (response)
      this.utl_getComponentRef(params[0]).setHidden(false);
    else
      this.utl_getComponentRef(params[0]).setHidden(true);
  }

  utl_showWhenNull(event, response) {
    let params = event.actionParams;
    if (response)
      this.utl_getComponentRef(params[0]).setHidden(true);
    else
      this.utl_getComponentRef(params[0]).setHidden(false);
  }

  utl_getActionsAndConditions(event) {
    let data = this.addActionsAndConditions(event);
    let newEvent = { actionParams: [], conditionParams: [] }
    newEvent.actionParams = data;
    newEvent.conditionParams = data;
    return newEvent;
  }

  utl_sumNumberFieldsValue(event) {
    let result = 0;//this.utl_getComponentRef(event.actionParams[0]).getValue();
    for (let i = 0; i < event.actionParams.length; i++)
      result += parseFloat(this.utl_getComponentRef(event.actionParams[i]).getValue() || 0);
    return { Data: result };
  }

  utl_subtractNumberFieldsValue(event) {
    let result = this.utl_getComponentRef(event.actionParams[0]).getValue();
    for (let i = 1; i < event.actionParams.length; i++)
      result -= parseFloat(this.utl_getComponentRef(event.actionParams[i]).getValue() || 0);
    return { Data: result };
  }

  utl_multiplyNumberFieldsValue(event) {
    let result = this.utl_getComponentRef(event.actionParams[0]).getValue();
    for (let i = 1; i < event.actionParams.length; i++)
      result *= parseFloat(this.utl_getComponentRef(event.actionParams[i]).getValue() || 0);
    return { Data: result };
  }

  utl_divideNumberFieldsValue(event) {
    let result = this.utl_getComponentRef(event.actionParams[0]).getValue();
    for (let i = 1; i < event.actionParams.length; i++)
      result /= parseFloat(this.utl_getComponentRef(event.actionParams[i]).getValue() || 0);
    return { Data: result };
  }

  utl_sumTableFieldValues(event) {
    let tableData = this.utl_getComponentRef(event.actionParams[0]).getTableData();
    let field = event.utilParams[0].name;
    let result = 0;

    for (let i = 0; i < tableData.length; i++)
      result += parseFloat(tableData[i].ArrayEntities.List.find(x => (x.Name === '' ? (x.Alias === field) : (x.Name === field))).Value || 0);
    return { Data: result };
  }

  /**
  Trigger an event of other component
  @param actionParams, component ids
  @param [FIELD] utilParam event name to raise
  */
  utl_triggerEvent(event) {
    let eventToInvoke = event.utilParams.find(x => x.dataSource === 'field');

    if (eventToInvoke) {
      for (let componentId of event.actionParams) {
        let component = this.utl_getComponentRef(componentId);

        if (component)
          component.event2(eventToInvoke.name);
      }
    }
  }

  utl_triggerEventIf(event, adn) {
    let sender = this.utl_getComponentRef(event.actionParams[0]);
    let argComponent = this.utl_getComponentRef(event.actionParams[1]);
    let evt = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'event');
    let ignoreBinding = event.utilParams.find(x => x.dataSource === 'field' && x.name === 'ignoreBinding');

    if (sender && evt) {
      if (!adn && argComponent) {
        if (argComponent.getCtType() === 'CtForm')
          adn = (argComponent.getHasBinding() || ignoreBinding ? argComponent.getBindingAdn() : null);
        else if (argComponent.getCtType() === 'CtTable')
          adn = argComponent.getSelectedAdn();
      }

      let triggerEvent = this.evaluateExpression(event.utilParams, adn);

      if (triggerEvent)
        sender.event2(evt.name.split('=')[1]);
    }
  }

  utl_storage(event, adn) {
    let source = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'source');
    let action = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'action');
    let field = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'field');
    let serialized = event.utilParams.find(x => x.dataSource === 'field' && x.name === 'serialized');

    if (source && action && field) {
      source = source.name.split('=')[1];
      action = action.name.split('=')[1];
      field = field.name.split('=')[1];

      if (action === 'SET') {
        if (serialized && adn)
          adn = JSON.stringify(adn);

        if (source === 'LOCAL')
          localStorage.setItem(field, adn);
        else if (source === 'SESSION')
          sessionStorage.setItem(field, adn);
      } else if (action === 'GET') {
        let value = null;

        if (source === 'LOCAL')
          value = localStorage.getItem(field);
        else if (source === 'SESSION')
          value = sessionStorage.getItem(field);

        if (value && serialized)
          value = JSON.parse(value);

        return value;
      } else if (action === 'REMOVE') {
        if (source === 'LOCAL')
          localStorage.removeItem(field);
        else if (source === 'SESSION')
          sessionStorage.removeItem(field);
      }
    }
  }

  /** 
  Opens modal
  @param actionParams, component ids
  */
  utl_openDialog(event: Action): void {
    let dialogRef = event.actionParams[0];
    let dialog = this.utilService.getComponentRef(dialogRef);
    dialog.openDialog();
  }

  utl_closeDialog(event: Action): void {
    let dialogRef = event.actionParams[0];
    let dialog = this.utilService.getComponentRef(dialogRef);

    if (dialog === null) {

      this.plusAlertService.closeDialog();

    } else {

      dialog.closeDialog();
    }
  }


  private getAdnFieldValue(adn, fieldName) {
    let field = adn.ArrayEntities.List.find(x => (x.Name ? (x.Name === fieldName) : (x.Alias === fieldName)));

    if (field)
      return field.Value;
    return null;
  }

  private evaluateExpression(args: any, adn: ADN_PLUS): boolean {
    let operator = 'OR';
    let isEnabled = (args.find(x => x.dataSource === 'field' && x.name === 'ALLOW_NULL') && !adn);

    if (adn) {
      for (let set of args) {
        if (set.dataSource === 'constant') {
          let field = set.name.split('=')[0];
          let checkValue = set.name.split('=')[1];

          if (field === 'INIT')
            isEnabled = (checkValue == 'true');
          else if (field === 'CONCAT')
            operator = checkValue;
          else {
            let attrValue = this.getAdnFieldValue(adn, field);
            let negateResult = false;

            if (checkValue.indexOf('_not_') === 0) {
              checkValue = checkValue.replace('_not_', '');
              negateResult = true;
            }

            if (checkValue === 'null')
              checkValue = null;

            if (negateResult) {
              if (operator === 'AND')
                isEnabled = isEnabled && (attrValue !== checkValue);
              else // OR
                isEnabled = isEnabled || (attrValue !== checkValue);
            } else {
              if (operator === 'AND')
                isEnabled = isEnabled && (attrValue === checkValue);
              else // OR
                isEnabled = isEnabled || (attrValue === checkValue);
            }
          }
        }
      }
    }

    if (args.find(x => x.dataSource === 'field' && x.name === 'NEGATE_CHECK'))
      isEnabled = !isEnabled;

    return isEnabled;
  }

  private addActionsAndConditions(event) {
    let data = [];
    let value = null;
    for (let param of event.utilParams) {
      switch (param.dataSource) {
        case "localStorage":
          value = localStorage.getItem(param.name);
          break;
        case "loggedUser":
          let loggedUser = JSON.parse(localStorage.getItem("loggedUser"));

          if (!loggedUser || !loggedUser.user) {
            value = null;
            break;
          }

          value = loggedUser.user[param.name.toLowerCase()];
          break;
      }
      data.push({ 'modelId': param.name.toUpperCase(), 'value': value })
    }
    return data;
  }

  // utl_getCurrentPeriod() {
  //   console.log(moment(new Date()).format('YYYYMM'));
  //   return { Data: moment(new Date()).format('YYYYMM') };
  // }

  utl_downloadFile(event) {
    for (let report of event.FilesData) {
      let byteArray = this.utilService.getByteArray(report);
      var blob = new Blob([byteArray], { type: 'pdf' });
      this.utilService.downloadPlusReport(report, blob);
    }
  }

  //Download report with custom name
  utl_downloadReport(report: any, fileType: string, fileName: string) {
      try {
        const byteArray = this.utilService.getByteArray(report);
        const mimeType = this.getMimeType(fileType);
        const blob = new Blob([byteArray], { type: mimeType });
        const fileFullName = `Sociedad de Seguros de Vida - ${fileName}`;
        this.utilService.createAdownloadATag(blob, fileFullName);
      } catch (error) {
        throw new Error("Failed to download report: " + error.message);  // More detailed error handling
      }
    }

    getMimeType(fileType: string): string {
      return fileType === 'pdf' 
        ? 'application/pdf' 
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }


  utl_loadSelectOptions(event: any, adn: any) {
    for (let param of event.actionParams) {
      let select = this.utilService.getComponentRef(param);

      if (select) {
        if (adn != null && adn.length > 0) {
          select.adnList = adn;
          select.options = select.utilService.convertAdnToSelectOptions(adn, select.fieldValue, select.fieldText);
          if (!select.anyOption/* && select.getInitValue()[0] === "" && select.getValue() === ""/* && select.utilService.isOptionInList(select.options, select.getValue())*/) {
            select.setValue([select.options[0].value]);
            select.setInitValue([select.options[0].value]);
          } else {
            select.setValue("");
            select.setInitValue("");
          }

          if (select.hasOnChangeAction())
            select.onChange();
        } else {
          select.options = [];
        }
      }
    }
  }

  utl_toggleElementsVisibility(pEvent: Action) {
    let params = pEvent.actionParams;

    for (let vIndex = 0; vIndex < params.length; vIndex++) {

      let vElement = this.utl_getComponentRef(params[vIndex])

      vElement.setHidden(!vElement.getHidden());
    }
  }

  utl_showElements(pEvent: Action, pResponse) {
    let params = pEvent.actionParams;

    for (let vIndex = 0; vIndex < params.length; vIndex++) {

      let vElement = this.utl_getComponentRef(params[vIndex])

      if (vElement.getHidden())
        vElement.setHidden(false);
    }

    return { Data: pResponse };
  }

  utl_hideElements(pEvent: Action, pResponse) {
    let params = pEvent.actionParams;

    for (let vIndex = 0; vIndex < params.length; vIndex++) {

      let vElement = this.utl_getComponentRef(params[vIndex])

      if (!vElement.getHidden())
        vElement.setHidden(true);
    }

    return { Data: pResponse };
  }
  /**
   * Esconde el primer elemento, muestra el segundo elemento.
   * Ambos elementos se encuentran en el pEvent.actionParams.
   */
  utl_elementsNavigation(pEvent: Action, pResponse) {
    let params = pEvent.actionParams;

    this.utl_getComponentRef(params[0]).setHidden(true);

    this.utl_getComponentRef(params[1]).setHidden(false);

    return { Data: pResponse };
  }

  /**
   * Navega hacia otra vista preservando el estado de la actual
   * @param eventParams Lista de componentes empezando por el CtView que seran enviados por parametro a la nueva vista
   * @param parametro constante con el codigo de la vista a navegar
   */
  utl_goto(pEvent: Action) {
    let rootNodeId = pEvent.actionParams[0];
    let newView = pEvent.utilParams.find(x => x.dataSource == 'constant');
    let sucessNavigation = false;

    if (rootNodeId && newView) {
      let rootNode = this.utl_getComponentRef(rootNodeId);
      let queryParams = {};

      for (let i = 1; i < pEvent.actionParams.length; i++) {
        let arg = this.utl_getComponentRef(pEvent.actionParams[i]);

        if (arg) {
          let argVal: any = null;

          if (arg.getCtType() === 'CtForm')
            argVal = arg.getBindingAdn();
          else if (arg.getCtType() === 'CtTable')
            argVal = arg.getSelectedAdn();
          else
            argVal = arg.getValue();

          if (argVal instanceof ADN_PLUS || argVal instanceof Array || argVal instanceof Object)
            argVal = JSON.stringify(argVal);

          let argCompId = arg['id'];

          if (arg.metaData.controlProperties['modelId'])
            argCompId = arg.metaData.controlProperties['modelId'];

          queryParams[argCompId] = btoa(argVal);
        }
      }

      let viewCode = newView.name.split("=")[1];
      let viewTitle = this.menuService.getViewTitle(viewCode);
      sucessNavigation = this.breadCrumbService.navigateTo('home/ssvmn/', viewCode, viewTitle, queryParams, false, rootNode);
    }

    return sucessNavigation;
  }

  /**
   * Cierra la vista actual y regresa a la anterior
   */
  utl_back(pEvent: Action) {
    this.location.back();
  }

  /**
   * Obtiene la lista de parametros de URL que existen actualmente
   */
  utl_getUrlParams(pEvent: Action) {
    return this.breadCrumbService.getUrlParams();
  }

  /**
   * Obtiene el valor de un parametro de URL
   * @param parametro tipo FIELD con el nombre del parametro de la URL (solo desde Editor), nombre del parametro como string (solo desde controlador)
   */
  utl_getUrlParamValue(arg: any, isEncoded: boolean = true) {
    let paramName = null;
    let value: any = null;

    if (typeof arg === 'string' || arg instanceof String)
      paramName = arg;
    else {
      let param = arg.utilParams.find(x => x.dataSource === 'field');
      let argEncoded = arg.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'isEncoded');

      if (argEncoded)
        isEncoded = argEncoded.name.split('=')[1] === 'true';

      if (param)
        paramName = param.name;
    }

    if (paramName) {
      value = this.breadCrumbService.getUrlParamValue(paramName);

      if (value && isEncoded)
        value = atob(value);
    }

    return value;
  }

  utl_deselectTables(pEvent: any, pResponse: any) {
    let vComponentsRef = pEvent.actionParams;

    for (let vComponentRef of vComponentsRef) {

      let vComponent = this.utl_getComponentRef(vComponentRef);

      if (vComponent.getCtType() !== "CtTable")
        continue;

      vComponent = vComponent;

      if (vComponent.selected) {
        vComponent.selected.selected = false;
        vComponent.selected = null;
      }

      vComponent.selectedRows = [];
      vComponent.cleanFormAndListeners();

      let storage = sessionStorage;

      let vViewTables = JSON.parse(storage.getItem('ViewTables'));
      delete vViewTables[vComponent.getId()];
      storage.setItem('ViewTables', JSON.stringify(vViewTables));

      vComponent.event2('onDeselect');

      return;
    }
  }

  utl_selectAllRecords(pEvent: any, pResponse: any) {
    let vComponentsRef = pEvent.actionParams;

    for (let vComponentRef of vComponentsRef) {

      let vComponent = this.utl_getComponentRef(vComponentRef);

      if (vComponent.getCtType() !== "CtTable")
        continue;

      vComponent = vComponent;

      if (vComponent.selected) {
        vComponent.selected.selected = false;
        vComponent.selected = null;
      }

      vComponent.selectedRows = [];
      vComponent.selectedAdns = [];

      for (let r of vComponent.rows) {
        r.selected = true;
        vComponent.selectedRows.push(r);
        vComponent.selectedAdns.push(r.adn);
      }

      let storage = sessionStorage;

      let vViewTables = JSON.parse(storage.getItem('ViewTables'));
      delete vViewTables[vComponent.getId()];
      storage.setItem('ViewTables', JSON.stringify(vViewTables));

      vComponent.event2('onSelect');
    }
  }


  // utl_resizeDt(pEvent: any, pResponse: any) {
  //   let components = pEvent.actionParams;
  //   for (let id of components) {
  //     setTimeout(() => {
  //       $('#dt' + id).resize();
  //     });
  //   }
  // }

  /**
   * 
   * @param evt
   * @param specDataList
   * @category Component
   * @edgBehavior Reference
   */
  utl_buildDynamicForm(evt: any, specDataList: ADN_PLUS[]): CtrlBaseComponent[] {
    let frm = this.utl_getComponentRef(evt.actionParams[0]);
    let frmBdy = this.utl_getComponentRef(evt.actionParams[1]);
    let columnCount = parseInt(this.utilService.getEventUtilParam(evt, 'columnCount', 'constant'));
    let dynamicModels = [];
    let rowModel;
    let lastRowId = -1;

    for (let i = 0; i < specDataList.length; i++) {
      let modelSpec = specDataList[i];

      if (!rowModel || rowModel.models >= columnCount) {
        lastRowId = i % columnCount;

        rowModel = this.getComponentBaseSpec('row_' + lastRowId, 'CtRow');
        rowModel.controlProperties.parentId = frmBdy.getId();
        rowModel.controlProperties.title = this.utilService.getStringAttribute("ROW_TITLE", modelSpec.ArrayEntities.List);
        dynamicModels.push(rowModel);
      }

      let colModel: any = this.getComponentBaseSpec('col_' + lastRowId + '_' + i, 'CtColumn');
      colModel.controlProperties.parentId = rowModel.id;
      colModel.controlProperties.size = 12 / columnCount;
      rowModel.models.push(colModel);

      var model: any = this.getComponentBaseSpecFromAdn(new ADN_PLUS(modelSpec));
      model.controlProperties.parentId = colModel.id;
      colModel.models.push(model);
    }

    let childElements = this.addChildrenToComponent({ "models": dynamicModels }, frmBdy);
    setTimeout(() => frm.updateFormElements());

    return childElements;
  }

  addChildrenToComponent(childrenSpec: any, parentContainer: any): CtrlBaseComponent[] {
    let childElements = this.paintService.paintChildren(childrenSpec, this.compiler, parentContainer.target);
    parentContainer.addChildren(childElements);
    return childElements;
  }

  getComponentBaseSpec(id: string, type: string) {
    if (!id)
      id = 'cg_' + type + '_' + Math.round(Math.random() * 10000);

    let spec = {
      "id": id,
      "ctType": type,
      "controlActions": [],
      "controlProperties": {
        "id": id,
        "ctType": type,
        "parentId": null
      },
      "models": []
    };

    return spec;
  }

  getComponentBaseSpecFromAdn(adnSpec: ADN_PLUS): any {
    let id = adnSpec.getStringAttribute('id');
    let type = adnSpec.getStringAttribute('ctType');

    let spec = {
      "id": id,
      "ctType": type,
      "controlActions": [],
      "controlProperties": {},
      "models": []
    };

    for (let field of adnSpec.ArrayEntities.List)
      spec.controlProperties[field.Name] = field.Value;

    return spec;
  }

  getComponentEventSpec(eventName: string, typeStr: string, actionStr: string) {
    let typeInt = 3; // VIEW

    if (typeStr === 'CRUD')
      typeInt = 4;
    else if (typeStr === 'ACTION')
      typeInt = 5;

    let spec = {
      "eventName": eventName,
      "type": typeInt,
      "action": actionStr, /* ENTITY.OPERATION.ApiEndpoint */
      "actionParams": [], /* Collection of component IDs */
      "conditionParams": [], /* Collection of component IDs */
      "utilParams": [], /* Collection of objects {"dataSource":'', "name":''} */
      "preAction": null,
      "postAction": null,
      "params": []
    };

    return spec;
  }

  /**
   * Limpia todos los componentes que sean parametrizados.
   */
  utl_clean(pAction, pResponse) {
    let componentsRef = pAction.actionParams;

    for (let componentRef of componentsRef) {
      let component = this.utilService.getComponentRef(componentRef);

      switch (component.getCtType()) {
        case 'CtTable':
          if (component && component.getCtType() === 'CtTable') {
            component.setDynamicProperties(component, 'tableData', null);
            component.updateTable(false);
          }
          break;
        case 'CtDataTable':
          component.setDynamicProperties(component, 'tableData', null);
          component.updateTable();
          break;
        case 'CtForm':
          component.updateBindingAdn(null);
          break;
        case 'CtEmailForm':
          component.clear();
          break;
        case 'CtRadio':
          component.clearSelectionVisual();  
          break;
        default:
          component.setValue("");
          break;
      }
    }
  }

  /**
   * Deshabilita todos los componentes parametrizados.
   */
  utl_disable(pAction, pResponse) {
    let componentsRef = pAction.actionParams;

    for (let componentRef of componentsRef) {
      let component = this.utilService.getComponentRef(componentRef);

      if (component.getCtType() === 'CtButton')
        component.setDisabled(true);
      else
        component.setReadOnly(true);
    }
  }

  /**
   * Habilita todos los componentes parametrizados.
   */
  utl_enable(pAction, pResponse) {
    let componentsRef = pAction.actionParams;

    for (let componentRef of componentsRef) {
      let component = this.utilService.getComponentRef(componentRef);

      if (component.getCtType() === 'CtButton')
        component.setDisabled(false);
      else
        component.setReadOnly(false);
    }
  }

  /**
   * Construye un ADN con los inputs parametrizados
   * @param evt evento de framework
   */
  // utl_buildAdn(evt) {
  //   let adn = new ADN_PLUS();
  //   let asData = evt.utilParams.find(x => x.dataSource === 'field' && x.name === 'AS_DATA');

  //   for (let componentRef of evt.actionParams) {
  //     let component = $("#" + componentRef).data("angularRef");

  //     if (component)
  //       adn.addAttribute(component.getModelId(), component.getValue());
  //   }

  //   if (asData)
  //     return { Data: adn };
  //   return adn;
  // }

  utl_getAdnFromAnyComponent(event, reponse) {
    return this.utilService.getAdnFromAnyComponent(event.actionParams[0]);
  }

  utl_showHideFromResponse(e, r) {
    let componentsRef = e.actionParams;

    for (let componentRef of componentsRef) {
      let component = this.utilService.getComponentRef(componentRef);

      if (component.getCtType() === 'CtButton')
        component.setDisabled(r);
      else
        component.setReadOnly(r);
    }
  }
  /**
   * Vuelve a poner todos los steps en su estado inicial.
   * @param evt evento de framework
   */
  utl_resetStepItem(e, r) {
    let stepperItem = this.utilService.getComponentRef(e.actionParams[0]);
    if (stepperItem) {
      stepperItem.loaded = false;
      stepperItem.setReadOnly(true);
    }
  }

  utl_setContextAdn(e, r) {
    let stepperItem = this.utilService.getComponentRef(e.actionParams[0]);
    if (stepperItem) {
      stepperItem.setContextAdn(r);
    }
  }

  utl_changeStep(e, r) {
    let stepper = this.utilService.getComponentRef(this.utilService.getEventUtilParam(e, 'stepperId', 'constant'));
    let stepperItemId = this.utilService.getEventUtilParam(e, 'stepperItemId', 'constant');
    if (stepper) {
      stepper.stepperInstace.goTo((stepper.getSteppIndex(stepperItemId) + 1));
      stepper.loadValues(stepperItemId);
    }
  }

  utl_triggerEventIfNotNull(e, r) {
    let component = this.utilService.getComponentRef(e.actionParams[0]);
    if (component && component instanceof InputBaseComponent) {
      let value = component.getValue();
      value = (value instanceof Array) ? value[0] : value;
      if (value && value != 'null') {
        return;
      }
    }
    return false;
  }

  /**
* Invoca un evento de los componentes parametrizados despues de cierto tiempo
* @param actionParams: lista de componentes a los cuales invocar el evento
* @param utilParam tipo constant: event=onCustomEvent (evento a invocar)
* @param utilParam tipo constant: timeout=1000 (delay en milisegundos)
*/
  utl_delayEvent(evt) {
    let evtToInvoke = evt.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'event');
    let delay = evt.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'timeout');

    if (evtToInvoke && delay) {
      evtToInvoke = evtToInvoke.name.split('=')[1];
      delay = parseInt(delay.name.split('=')[1]);

      setTimeout(() => {
        for (let compId of evt.actionParams) {
          let comp = this.utl_getComponentRef(compId);

          if (comp)
            comp.event2(evtToInvoke);
        }
      }, delay);
    }
  }

  /**
   * Valida los registros de una tabla editable para habilitar o no el evento de edicion
   * @param actionParams: tabla editable a validar
   * @param utilParams: lista de validaciones a aplicar por cada registro
   */
  utl_checkTableEdit(evt: any) {
    let tbl = this.utilService.getComponentRef(evt.actionParams[0]);

    if (tbl) {
      for (let row of tbl.rows)
        row.canEdit = this.evaluateExpression(evt.utilParams, row.adn);
    }
  }

  // utl_triggerIfNotTableRowSelected(e, r) {
  //   let component = this.utilService.getComponentRef(e.actionParams[0]);
  //   if (component && component instanceof CtTableComponent) {
  //     if (!component.getSelectedAdn()) {
  //       return;
  //     }
  //   }
  //   return false;
  // }

  /**
   * Valida que haya un registro seleccionado en una tabla desde util o event param
   */
  // utl_triggerIfTableRowSelected(e, r) {
  //   let tableId;
  //   if (e.actionParams.length > 0)
  //     tableId = e.actionParams[0]
  //   else
  //     tableId = this.utilService.getEventUtilParam(e, 'tableId', 'constant')

  //   let component = this.utilService.getComponentRef(tableId);

  //   if (component && component instanceof CtTableComponent) {
  //     if (component.getSelectedAdn()) {
  //       return;
  //     }
  //   }
  //   return false;
  // }

  /**
   * Setea propiedades de los componentes
   * @param actionParams lista de componentes
   * @param utilParam lista de constantes propiedad=valor
   * @category Event
   * @edgBehavior Reference
   */
  utl_setProperty(evt: any): void {
    for (let compId of evt.actionParams) {
      let comp = <CtrlBaseComponent>this.utl_getComponentRef(compId);

      if (comp) {
        for (let constProp of evt.utilParams) {
          if (constProp.dataSource === 'constant') {
            let pair = constProp.name.split('=');
            comp.setDynamicProperties(comp, pair[0], pair[1]);
          }
        }
      }
    }
  }

  utl_forceBindForm(evt: any) {
    for (let compId of evt.actionParams) {
      const form = <CtFormComponent>this.utl_getComponentRef(compId);
      setTimeout(() => {
        form.bindAdnToForm();
      });
    }
  }

  utl_openSidebar(e, r) {
    let comp = <CtrlBaseComponent>this.utl_getComponentRef(e.actionParams[0]) as CtSidebarComponent;

    if (comp) {
      comp.open();
      return r;
    }

    return false;
  }

  utl_closeSidebar(e, r) {
    let comp = <CtrlBaseComponent>this.utl_getComponentRef(e.actionParams[0]) as CtSidebarComponent;

    if (comp) {
      comp.close();
      return r;
    }

    return false;
  }

  utl_nextStepV4(e, r) {
    let comp = <CtrlBaseComponent>this.utl_getComponentRef(e.actionParams[0]) as CtStepperComponent;

    if (comp) {
      let current = comp.getCurrentIndex();

      if (current >= 0 && current < (comp.stepperItems.length - 1)) {
        comp.changeStep(current + 1);
      }

      return r;
    }

    return false;
  }

  utl_prevStepV4(e, r) {
    let comp = <CtrlBaseComponent>this.utl_getComponentRef(e.actionParams[0]) as CtStepperComponent;

    if (comp) {
      let current = comp.getCurrentIndex();

      if (current >= 0 && current < (comp.stepperItems.length - 1)) {
        comp.changeStep(current - 1);
      }

      return r;
    }

    return false;
  }

  /**
   * gets the CtMessageComponent reference and shows it.
   */
  utl_show_message(event: Action, response: any): void {
    const messageComponent = this.utilService.getComponentRef(event.actionParams[0]);
    if (!messageComponent) {
      this.plusMessageService.showMessage(response[0]);
      return;
    };
    messageComponent.showMessage();
  }

  /**
   * gets the CtMessageComponent reference and hides it.
   */
  utl_hide_message(event: Action): void {
    const messageComponent = this.utilService.getComponentRef(event.actionParams[0]);
    if (!messageComponent) {
      this.plusMessageService.hideMessage();
      return;
    };
    messageComponent.hideMessage();
  }

  /**
 * gets the CtDialogComponent reference and shows it.
 */

  /**
   * Sets data to Otp Component
   * send form from the editor with these input model ids: OTP_COMPONENT_ID, CONTACT_VERIFY,NOTIFICATION_TARGET,USER_IDENTIFIER
   * send data values to this function as well as the component id (optional)
   */
  utl_set_otp_data(event?: Action, otpComponentId? : string, contactVerify? : string, notificationTarget? : string,
    userIdentifier? : string): void {
    
    const otpComponent : CtOtpComponent = event != null ? this.utilService.getComponentRef(event.conditionParams[0]) 
      : this.utilService.getComponentRef(otpComponentId);
    
    if(event){
      const formComponent : CtFormComponent = this.utilService.getComponentRef(event.conditionParams[1]);
      otpComponent.setDataToOtp(
        formComponent.getFormElementByModelId('CONTACT_VERIFY').getValue(),
        formComponent.getFormElementByModelId('NOTIFICATION_TARGET').getValue(),
        formComponent.getFormElementByModelId('USER_IDENTIFIER').getValue()
      );
    } else {
      otpComponent.setDataToOtp(contactVerify,
        notificationTarget,
        userIdentifier);
    }
  }

  /**
   * Receives from the event the location to navigate to.
   */
  utl_navigateTo(event: Action){
    let view = event.utilParams.find(x => x.dataSource === 'constant');
    if (view){
    let vista = view.name.split("=")[1] 
    this.router.navigate([`home/view/${vista}`]);
    }
  }

  utl_set_state(event : Action, adn) {
    let { key, value } = this.utilService.getUtlStoreServiceValues(event);
    if(!key) return;

    if(value) {
      this.utilService.updateStateWithKeyValue(key, value);
      return;
    }

    if(!adn) return;
    this.storeService.setState(this.utilService.extractValueFromPair(key), adn);
  }

  utl_get_state(event : Action) {
    const { key, component } = this.utilService.getUtlStoreServiceComponentValues(event);
    if(!key || !component) return;

    this.utilService.setStateToComponent(key, component);
  }

  utl_delete_state(event : Action) {
    const key = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'key');
    if(!key) return;

    this.storeService.deleteState(this.utilService.extractValueFromPair(key));
  }

  utl_delete_all_states() {
    this.storeService.deleteAllStates();
  }

  utl_open_GuidedTourDialog(event: Action) {
    const userRoles : string[] = this.authService.getUserRoles();
    let component : CtrlBaseComponent;
    let position : ElementViewportPosition;
    const dialog: CtDialogComponent = this.utilService.getComponentRef(event.actionParams[0]);
    const menuOption = this.extractMenuOption(event);
    if (!menuOption) {
      component = this.utilService.getComponentRef(dialog.getGuidedTourTargetComponentId());
      position = component.getViewportPosition();
    } else {
      position = dialog.getViewportPosition(menuOption);
    }
    if (!position) return;
    dialog.setPosition(position);
    this.openGuidedTourDialog(userRoles, dialog)
  } 

  /**
   * If the current user is not authorized to see the guided tour dialog, it'll pass to the next
   * dialog on the guided tour. repeating the process until it finds a dialog the user is authorized to see.
   * @param userRoles 
   * @param dialog 
   * @returns 
   */
  private openGuidedTourDialog(userRoles : string[], dialog: CtDialogComponent) {
    const rolesNotAuthorized = dialog.getHideWhenKeyValue();
    if (rolesNotAuthorized && userRoles.some(role => rolesNotAuthorized.includes(role))) {
      dialog.event2('onClick');
      return;
    } else {
      dialog.openDialog();
    }
  }
  
  extractMenuOption(event: Action): string | undefined {
    const menuOptionParam = event.utilParams.find(param => 
      param.dataSource === 'constant' && param.name.startsWith('menuOption')
    );
    return menuOptionParam?.name.split('=')[1];
  }

  utl_flush_user_menu(action : Action) {
    this.menuService.flushUserMenu();
  }

  utl_setOtpModelFromRadioOnClickToMiniOtp(event: Action) {
    const otpComponent : CtOtpComponent = this.utilService.getComponentRef(event.actionParams[0]);
    otpComponent.setOtpModelFromRadioOnClick();
  }
}